import yup from 'utils/yup';

export const initialConnectModalFormData = {
  paychex_company_id: '',
};

export const connectPaychexApiValidationSchema = yup.object().shape({
  paychex_company_id: yup.string().required(),
});
